module.exports = __webpack_public_path__ + "img/logoM.ee9eccbd.png";